<h3 class="p-form-layout01__item-title c-heading-2" [innerHTML]="'label.managementCodeTitle' | staticMsg"></h3>
<div class="p-form-layout01">
  <div class="p-form-layout01__item">
    <br />
    <!--搭乗者を繰り返し表示-->
    <form>
      <ng-container *ngFor="let traveler of anabizPassengerInfoList; let i = index">
        <ng-container [formGroup]="corpManagementCodeForm.at(i)">
          <span class="managementCode__title" [innerHtml]="traveler.name"> </span>
          <div *ngIf="showLabel" class="managementCode__input">
            <div *ngIf="this.anabizPassengerInfoList[i].showCode1 === true" class="managementCode__container">
              <span class="managementCode__container__elem__title" [innerHtml]="corporateManagementTextItems[0]"></span>
              <span
                class="managementCode__container__elem"
                [innerHtml]="this.anabizPassengerInfoList[i].companyManagementCode1"
              ></span>
            </div>
            <div *ngIf="this.anabizPassengerInfoList[i].showCode2 === true" class="managementCode__container">
              <span class="managementCode__container__elem__title" [innerHtml]="corporateManagementTextItems[1]">
              </span>
              <span
                class="managementCode__container__elem"
                [innerHtml]="this.anabizPassengerInfoList[i].companyManagementCode2"
              ></span>
            </div>
            <div *ngIf="this.anabizPassengerInfoList[i].showCode3 === true" class="managementCode__container">
              <span class="managementCode__container__elem__title" [innerHtml]="corporateManagementTextItems[2]">
              </span>
              <span
                class="managementCode__container__elem"
                [innerHtml]="this.anabizPassengerInfoList[i].companyManagementCode3"
              ></span>
            </div>
          </div>
          <div *ngIf="showLabel" class="managementCode__select">
            <div *ngIf="this.anabizPassengerInfoList[i].showCode4 === true" class="managementCode__container">
              <span class="managementCode__container__elem__title" [innerHtml]="corporateManagementTextItems[3]">
              </span>
              <span
                class="managementCode__container__elem"
                [innerHtml]="this.anabizPassengerInfoList[i].companyManagementCode4"
              ></span>
            </div>
          </div>
          <div *ngIf="!showLabel" class="managementCode__input">
            <asw-input
              id="anabiz-corporate-management-code-input1-{{ i }}"
              *ngIf="this.anabizPassengerInfoList[i].showCode1 === true"
              [label]="corporateManagementTextItems[0]"
              [value]="this.anabizPassengerInfoList[i].companyManagementCode1 ?? ''"
              formControlName="companyManagementCode1"
              (change$)="companyManagementCode1Change(i)"
            ></asw-input>
            <asw-input
              id="anabiz-corporate-management-code-input2-{{ i }}"
              *ngIf="this.anabizPassengerInfoList[i].showCode2 === true"
              [label]="corporateManagementTextItems[1]"
              [value]="this.anabizPassengerInfoList[i].companyManagementCode2 ?? ''"
              formControlName="companyManagementCode2"
              (change$)="companyManagementCode2Change(i)"
            ></asw-input>
            <asw-input
              id="anabiz-corporate-management-code-input3-{{ i }}"
              *ngIf="this.anabizPassengerInfoList[i].showCode3 === true"
              [label]="corporateManagementTextItems[2]"
              [value]="this.anabizPassengerInfoList[i].companyManagementCode3 ?? ''"
              formControlName="companyManagementCode3"
              (change$)="companyManagementCode3Change(i)"
            ></asw-input>
          </div>
          <div *ngIf="!showLabel" class="managementCode__select">
            <div
              *ngIf="this.anabizPassengerInfoList[i].showCode4 === true"
              class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325"
            >
              <asw-select
                id="anabiz-corporate-management-code-input4-{{ i }}"
                [label]="corporateManagementTextItems[3]"
                [selected]="this.anabizPassengerInfoList[i].companyManagementCode4 ?? ''"
                formControlName="companyManagementCode4"
                (change$)="companyManagementCode4Change(i)"
              >
                <option value="" [innerHTML]="'placeholder.pleaseSelect' | staticMsg"></option>
                <option
                  *ngFor="let item of corporateManagementCode4ComboOptions"
                  [value]="item"
                  [innerHTML]="item"
                ></option>
              </asw-select>
            </div>
          </div>
          <br />
        </ng-container>
      </ng-container>
    </form>
  </div>
</div>
